<div class="modal__content">
    <div class="select">
        <select class="input" name="selectedObject" id="selectedObject" [(ngModel)]="options.settings.stickerOnItem">
            <option *ngFor="let placement of stickerPlacement" value="{{placement.onItem}}">{{placement.name}}</option>
        </select>
    </div>
</div>
<modal-actions [options]="options" [type]="type"></modal-actions>
